import { ReducerBuilder } from './reducerBuilder';
import { AccountNotificationState } from 'acscp/store/accountNotificationState';
import { AccountNotificationsRequest, NotificationMarkAsReadRequest } from 'acscp/api/requests';
import { AccountNotificationsList } from 'acscp/api/models/accountNotificationsList';

export const accountNotificationReducer =
    new ReducerBuilder<AccountNotificationState>({})
        .successfulRequestCase(AccountNotificationsRequest, (state, response: AccountNotificationsList) => {
            const newState: AccountNotificationState = {};

            const storedNotifications = Object.keys(state).map(key => state[key]);

            storedNotifications
                .concat(response)
                .forEach(quote => {
                    newState[quote.id] = quote;
                });

            return newState;
        })
        .successfulRequestCase<undefined, NotificationMarkAsReadRequest>(NotificationMarkAsReadRequest,
            (state, payload, request) => {
                const storeAccountNotifications: AccountNotificationState = {};
                Object.keys(state).forEach(n => storeAccountNotifications[n] =
                    request.notificationIds.indexOf(n) > -1 ? {...state[n], hasBeenRead: true} : state[n]);
                return storeAccountNotifications;
            })
        .build();
